import React from "react";

const LOGO_URL = "/assets/brand/kz-logo-premium.png";

const handleScroll = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      id="hero"
      className="relative min-h-screen flex flex-col items-center justify-center px-6 sm:px-10 py-24"
    >
      {/* Top bar */}
      <div className="absolute top-0 left-0 right-0 px-6 sm:px-10 py-6 flex items-center justify-between text-[11px] sm:text-xs uppercase tracking-[0.25em]" style={{ color: "var(--kz-text-secondary)" }}>
        <span className="font-display font-medium">KZ — Est. Environmental Services</span>
        <a
          data-testid="hablamos-espanol-badge"
          href="#contact"
          onClick={(e) => { e.preventDefault(); handleScroll("contact"); }}
          className="hablamos-badge font-display font-medium inline-flex items-center gap-2 px-3 py-1.5 rounded-full"
          aria-label="Hablamos Español — Spanish service available"
        >
          <span aria-hidden="true" className="hablamos-dot" />
          <span>Hablamos Español</span>
        </a>
      </div>

      {/* Subtle accent corners */}
      <div className="pointer-events-none absolute top-20 left-6 sm:left-10 w-10 h-10 border-l border-t" style={{ borderColor: "var(--kz-accent)", opacity: 0.5 }} />
      <div className="pointer-events-none absolute top-20 right-6 sm:right-10 w-10 h-10 border-r border-t" style={{ borderColor: "var(--kz-accent)", opacity: 0.5 }} />

      <div className="relative max-w-5xl w-full flex flex-col items-center text-center">
        {/* Logo with glow */}
        <div className="logo-glow fade-up fade-up-1 mb-10 sm:mb-12 w-full flex items-center justify-center">
          <img
            data-testid="kz-logo"
            src={LOGO_URL}
            alt="KZ Environmental"
            className="w-full max-w-[820px] sm:max-w-[1000px] md:max-w-[1100px] lg:max-w-[1200px] h-auto select-none"
            draggable={false}
            loading="eager"
          />
        </div>

        {/* Slogan */}
        <div
          data-testid="hero-slogan"
          className="hero-slogan fade-up fade-up-2 w-full max-w-4xl mx-auto mb-12 sm:mb-14 px-2"
        >
          <p className="font-display font-medium text-xl sm:text-2xl md:text-3xl leading-[1.25] tracking-tight text-center">
            Keeping Your Crews,{" "}
            <span style={{ color: "var(--kz-accent)" }}>Fleets</span> &amp;
            Operations Moving.
          </p>
        </div>

        {/* CTA */}
        <button
          data-testid="hero-cta-quote"
          onClick={() => handleScroll("contact")}
          className="cta-button fade-up fade-up-3 group inline-flex items-center gap-4 px-8 sm:px-10 py-4 sm:py-5 font-display text-xs sm:text-sm uppercase tracking-[0.3em] font-semibold rounded-none"
          style={{
            background: "var(--kz-accent)",
            color: "var(--kz-bg)",
            border: "1px solid var(--kz-accent)",
          }}
        >
          <span className="relative z-10">Request a Quote</span>
          <span
            className="relative z-10 inline-block w-8 h-px transition-transform duration-500 group-hover:translate-x-1"
            style={{ background: "var(--kz-bg)" }}
          />
        </button>
      </div>

      {/* Scroll indicator */}
      <div
        data-testid="scroll-indicator"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 fade-up fade-up-4"
      >
        <span
          className="font-display text-[10px] uppercase tracking-[0.4em]"
          style={{ color: "var(--kz-text-secondary)", opacity: 0.6 }}
        >
          Scroll
        </span>
        <div className="v-line h-12" />
      </div>
    </section>
  );
};

export default Hero;
